import { minPreis, preis, gleicheSku, PflegeboxProduktLike, PflegeboxSkuLike } from '@saniup-webapps/shared/phm'
import { PflegeboxProdukt, PflegeboxProduktSku } from '../model/selfservice.model'

/**
 * Preis- und SKU-Vergleich liegen seit 08/2026 in `@saniup-webapps/shared/phm` — dieselben Regeln
 * braucht das Leistungserbringer-Portal, und die 42-€-Grenze hängt daran.
 *
 * <p>Diese Datei bleibt als schmale Brücke: sie bindet die strukturellen Typen der Bibliothek an die
 * generierten der App, sodass die 15 Aufrufstellen unverändert bleiben.
 */

export function equalSku(a?: PflegeboxProduktSku, b?: PflegeboxProduktSku): boolean {
  return gleicheSku(a as PflegeboxSkuLike | undefined, b as PflegeboxSkuLike | undefined)
}

export function price(product: PflegeboxProdukt, sku: PflegeboxProduktSku): number {
  return preis(product as PflegeboxProduktLike, sku as PflegeboxSkuLike)
}

export function minPrice(product: PflegeboxProdukt): number | undefined {
  return minPreis(product as PflegeboxProduktLike)
}
